import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PasswordResetStateService {
  private readonly emailAddressSignal = signal<string | null>(null);
  private readonly successMessageSignal = signal<string | null>(null);

  readonly emailAddress = this.emailAddressSignal.asReadonly();
  readonly successMessage = this.successMessageSignal.asReadonly();

  setEmail(emailAddress: string): void {
    this.emailAddressSignal.set(emailAddress);
  }

  setSuccessMessage(message: string): void {
    this.successMessageSignal.set(message);
  }

  /** Returns and clears the one-shot success message for the login screen. */
  consumeSuccessMessage(): string | null {
    const message = this.successMessageSignal();
    this.successMessageSignal.set(null);
    return message;
  }

  /** Returns and clears the one-shot email for login prefill after a successful cloud password reset. */
  consumeEmail(): string | null {
    const emailAddress = this.emailAddressSignal();
    this.emailAddressSignal.set(null);
    return emailAddress;
  }

  clearEmail(): void {
    this.emailAddressSignal.set(null);
  }

  reset(): void {
    this.emailAddressSignal.set(null);
    this.successMessageSignal.set(null);
  }
}
